/** @format */

import { Cta } from '@dcsg-ngx-ecommerce/engage';
export class Accordion {
	public question: string;
	public hasAccordionSection: boolean;
	// eslint-disable-next-line @typescript-eslint/no-empty-object-type
	public answer?: {};
	public cta?: Cta[];
	public accordionSection?: any[];

	constructor(
		question: string,
		hasAccordionSection: boolean,
		answer?: string,
		cta?: Cta[],
		accordionSection?: any[]
	) {
		this.question = question;
		this.hasAccordionSection = hasAccordionSection;
		this.answer = answer;
		this.accordionSection = accordionSection;
		this.cta = cta;
	}
}
